import { VStack } from "@/components/layout/VStack";
import { Button } from "@/components/ui/Button/Button";
import googleLogo from "@/assets/google-logo.svg";
import { useLogin } from "../hooks/useLogin";

const LoginPage = () => {
  const { startLogin } = useLogin();

  return (
    <VStack align="center" justify="center" style={{ height: "100dvh" }}>
      <Button variant="outline" onClick={startLogin}>
        <img src={googleLogo} height={16} width={16} />
        Continue with Google
      </Button>
    </VStack>
  );
};

export default LoginPage;
